<template>
    <form-fields>
        <toolbar-buttons :no-margins="true">
            <option-colors
                :available-colors="availableColors"
                :selected-color="selectedColor"
                :max-items="maxItems"
                @select="select"
            />
        </toolbar-buttons>

        <step-buttons
            :class="{
                'cz3__hide-lg': buttonsSm,
            }"
        >
            <secondary-button
                class="cz3__flex-1"
                :label="$t('V3_BACK')"
                @click="back"
            />

            <action-button
                class="cz3__flex-1"
                :label="$t('V3_NEXT')"
                @click="next"
            />
        </step-buttons>
    </form-fields>
</template>

<style lang="scss">
    @import "../../style/variables.scss";
</style>

<script>
    import ToolbarButtons from './ToolbarButtons.vue';
    import FormFields from './FormFields.vue';
    import ActionButton from './ActionButton.vue';
    import SecondaryButton from './SecondaryButton.vue';
    import StepButtons from './StepButtons.vue';
    import OptionColors from './OptionColors.vue';

    export default {
        components: {
            ToolbarButtons,
            FormFields,
            ActionButton,
            SecondaryButton,
            StepButtons,
            OptionColors,
        },

        props: {
            buttonsSm: Boolean,
            maxItems: Number,
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            editPlacements() {
                return this.$store.state.customizer.editPlacements;
            },

            editPlacement() {
                if (this.editPlacements && this.editPlacements.length > 0) {
                    return this.editPlacements[0];
                }

                return null;
            },

            editComponent() {
                if (this.editPlacement) {
                    return this.viewController.selectedAtPlacement(this.editPlacement.code);
                }

                return null;
            },

            /**
             * Figure out a list of available colors.
             */
            availableColors() {
                return this.$store.getters.availablePersonalizationColors;
            },

            selectedColor() {
                const color = this.editComponent.custom['effect-colorize-add'];

                return this.availableColors.find((x) => x.custom['personalization-color'] === color);
            },
        },

        methods: {
            back() {
                // Go back to... whereever.
                if (this.editComponent != null) {
                    const isGallery = this.editComponent.custom['gallery-image'] === 'true';

                    if (isGallery) {
                        this.$store.dispatch('setSelectedSubStepV3', 'gallery');
                        this.$store.dispatch('showImageGalleryV3', true);
                    }
                }
            },

            next() {
                // Should always be alignment.
                this.$store.dispatch('setSelectedSubStepV3', 'gallery-alignment');
            },

            select(color) {
                this.viewController.commitCustomAttributes(this.editPlacement.code, {
                    'effect-colorize': '000000',
                    'effect-colorize-add': color.custom.hex,
                    'effect-colorize-name': color.name,
                }, {
                    propagate: true,
                });
            },
        },
    };
</script>
